import { render, staticRenderFns } from "./DockingDashboard.vue?vue&type=template&id=182a3494"
import script from "./DockingDashboard.vue?vue&type=script&lang=js"
export * from "./DockingDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports